type $DocTypeEnums = {
  html: 'html';
  pdf: 'pdf';
};
export type $DocType = $DocTypeEnums[keyof $DocTypeEnums];

export const docType: $DocTypeEnums = {
  html: 'html',
  pdf: 'pdf',
};

type $AdminDocRouteEnums = {
  adminChampionshipDocument: 'admin/regatta_championship';
  adminRegattaDocument: 'admin/regatta_document';
  adminRegattaEntries: 'admin/regatta_entries';
  adminRegattaEntry: 'admin/regatta_entry';
  adminRegattaEntryEmpty: 'admin/regatta_entry_empty';
  adminRegattaGroupEntries: 'admin/regatta_group_entries';
  adminRegattaMessage: 'admin/regatta_message';
  adminRegattaProtest: 'admin/regatta_protest';
  adminRegattaProtests: 'admin/regatta_protests';
  adminRegattaResultOverall: 'admin/regatta_result_overall';
  adminRegattaResults: 'admin/regatta_results';
  adminRegattaResultTable: 'admin/regatta_result_table';
  adminRegattaResultTableEntries: 'admin/regatta_result_table_entries';
  adminRegattaSchedule: 'admin/regatta_schedule';
  adminRegattaTrackers: 'admin/regatta_trackers';
};

const adminDocRoute: $AdminDocRouteEnums = Object.freeze({
  adminChampionshipDocument: 'admin/regatta_championship',
  adminRegattaDocument: 'admin/regatta_document',
  adminRegattaEntries: 'admin/regatta_entries',
  adminRegattaEntry: 'admin/regatta_entry',
  adminRegattaEntryEmpty: 'admin/regatta_entry_empty',
  adminRegattaGroupEntries: 'admin/regatta_group_entries',
  adminRegattaMessage: 'admin/regatta_message',
  adminRegattaProtest: 'admin/regatta_protest',
  adminRegattaProtests: 'admin/regatta_protests',
  adminRegattaResultOverall: 'admin/regatta_result_overall',
  adminRegattaResults: 'admin/regatta_results',
  adminRegattaResultTable: 'admin/regatta_result_table',
  adminRegattaResultTableEntries: 'admin/regatta_result_table_entries',
  adminRegattaSchedule: 'admin/regatta_schedule',
  adminRegattaTrackers: 'admin/regatta_trackers',
});

type $PublicDocRouteEnums = {
  championshipDocument: 'championship_document';
  regattaDocument: 'regatta_document';
  regattaEntry: 'regatta_entry';
  regattaMessage: 'regatta_message';
  regattaProtest: 'regatta_protest';
  regattaProtests: 'regatta_protests';
  regattaResultTable: 'regatta_result_table';
};

const publicDocRoute: $PublicDocRouteEnums = Object.freeze({
  championshipDocument: 'championship_document',
  regattaDocument: 'regatta_document',
  regattaEntry: 'regatta_entry',
  regattaMessage: 'regatta_message',
  regattaProtest: 'regatta_protest',
  regattaProtests: 'regatta_protests',
  regattaResultTable: 'regatta_result_table',
});

type $DocRouteEnums = $AdminDocRouteEnums & $PublicDocRouteEnums;

export type $DocRoute = $DocRouteEnums[keyof $DocRouteEnums];

export const docRoute: $DocRouteEnums = Object.freeze({
  ...adminDocRoute,
  ...publicDocRoute,
});
